import React, { useContext } from 'react';
import { getAppEnv } from '../../../../config/env';
import {
  CAB_FROM_AIRPORT,
  CAB_TO_AIRPORT,
  OUTSTATION_ONE_WAY,
  OUTSTATION_ROUND_TRIP,
  RENTALS
} from '../../../constants/tripTypes';
import { CabsLandingContext } from '../../../CabsLandingContext';
const env = getAppEnv();
const { PUBLIC_URL } = env.raw;

export const TripTypeInfo = () => {
  const cabsLandingContext = useContext(CabsLandingContext);
  const { travelFor } = cabsLandingContext;

  return (
    <div
      className="makeFlex"
      style={{ backgroundColor: 'rgb(255, 237, 209)', padding: '5px 12px' }}
    >
      <img
        className="appendRight5"
        src={`${PUBLIC_URL}/static/public/info_yellow.webp`}
        height={'15px'}
        width={'15px'}
        alt="info"
      />
      <div
        style={{ color: 'rgb(207, 129, 0)' }}
        className="font12 latoRegular makeFlex vertlCenter"
      >
        {(() => {
          switch (travelFor) {
            case OUTSTATION_ONE_WAY:
              return `Includes one pick up & drop`;
            case OUTSTATION_ROUND_TRIP:
              return `Retain cab till return & include multiple stops`;
            case CAB_FROM_AIRPORT:
              return `Pre-book Airport pick ups`;
            case CAB_TO_AIRPORT:
              return `Pre-book Airport drops`;
            case RENTALS:
              return `Take multi stops, opt for any drop location in the city`;
          }
        })()}
      </div>
    </div>
  );
};
